if(window.innerWidth > 768) {
gsap.registerPlugin(ScrollTrigger);

let tl = gsap.timeline({
  scrollTrigger: {
    trigger: '.fizzyanimation_mainsec',
    start: 'top 40%',
    end: 'bottom top',
    scrub: false,
  }
});

tl.to('.main_artist_box_cap', {
  duration: 0.6,
  yPercent: -162,
  xPercent: 25,
  rotation: 49,
  ease: 'none',
});

const bubblePositions = [
  { xPercent: -41, yPercent: -162 }, // bubble 1
  { xPercent: 60, yPercent: -184 },  // bubble 2
  { xPercent: -140, yPercent: -148 }, // bubble 3
  { xPercent: 108, yPercent: -102 },  // bubble 4
  { xPercent: -70, yPercent: -150 },  // bubble 5
];

const bubbleDuration = 1;

document.querySelectorAll('.bubblecommon').forEach((bubble, index) => {
  const pos = bubblePositions[index] || { xPercent: 0, yPercent: -100 };
const position = index === 0 ? '+=0.2' : `-=${(bubbleDuration * 0.5).toFixed(2)}`;
  tl.to(bubble, {
    duration: bubbleDuration,
    scale: 1,
    opacity: 1,
    xPercent: pos.xPercent,
    yPercent: pos.yPercent,
    ease: 'back.out(1.7)',
  }, position); // overlap from 2nd bubble

  gsap.to(bubble, {
    y: `+=${gsap.utils.random(5, 12)}`,
    repeat: -1,
    yoyo: true,
    ease: 'sine.inOut',
    duration: gsap.utils.random(1, 2),
    delay: 1.4 + index * 0.2,
  });
});

}

// mobile animation

if(window.innerWidth < 768) {
gsap.registerPlugin(ScrollTrigger);

let tl = gsap.timeline({
  scrollTrigger: {
    trigger: '.fizzyanimation_mainsec',
    start: 'top 40%',
    end: 'bottom top',
    scrub: false,
  }
});

tl.to('.main_artist_box_cap', {
  duration: 0.6,
  yPercent: -162,
  xPercent: 25,
  rotation: 49,
  ease: 'none',
});

const bubblePositions = [
  { xPercent: -41, yPercent: -162 }, // bubble 1
  { xPercent: 60, yPercent: -184 },  // bubble 2
  { xPercent: -140, yPercent: -148 }, // bubble 3
  { xPercent: 108, yPercent: -102 },  // bubble 4
  { xPercent: -70, yPercent: -66 },  // bubble 5
];

const bubbleDuration = 1;

document.querySelectorAll('.bubblecommon').forEach((bubble, index) => {
  const pos = bubblePositions[index] || { xPercent: 0, yPercent: -100 };
const position = index === 0 ? '+=0.2' : `-=${(bubbleDuration * 0.5).toFixed(2)}`;
  tl.to(bubble, {
    duration: bubbleDuration,
    scale: 1,
    opacity: 1,
    xPercent: pos.xPercent,
    yPercent: pos.yPercent,
    ease: 'back.out(1.7)',
  }, position); // overlap from 2nd bubble

  // Step 5: Floating wiggle after pop
  gsap.to(bubble, {
    y: `+=${gsap.utils.random(5, 12)}`,
    repeat: -1,
    yoyo: true,
    ease: 'sine.inOut',
    duration: gsap.utils.random(1, 2),
    delay: 1.4 + index * 0.2,
  });
});

}



